/* Home-Button-Hinweis (Snippet cs-homebutton.liquid): togglet beim
   Variantenwechsel die Sichtbarkeit ueber die eingebettete JSON-Map
   (variant_id -> 1/0; 1 = iPad-Modell mit frontseitigem Home-Button).
   Progressive Enhancement: der Initialzustand kommt serverseitig aus Liquid. */
if (!customElements.get('cs-homebutton')) {
  customElements.define(
    'cs-homebutton',
    class CsHomebutton extends HTMLElement {
      connectedCallback() {
        const mapEl = this.querySelector('[data-cs-homebutton-map]');
        try {
          this.map = mapEl ? JSON.parse(mapEl.textContent) : {};
        } catch (e) {
          this.map = {};
        }
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (!this.belongsToUs(event.data)) return;
            const variant = event.data.variant;
            this.hidden = !(variant && this.map[variant.id]);
          });
        }
      }

      /* Das Event nennt nur eine sectionId. Die aus Liquid gesetzte
         data-section-id passt im Shop, weicht im Theme-Editor und bei
         Quick-Add aber ab (dort publiziert Dawn data-original-section).
         Deshalb gegen alle IDs des eigenen product-info-Vorfahren pruefen
         und zusaetzlich akzeptieren, wenn die Variante zu diesem Produkt
         gehoert - die Map enthaelt ALLE Varianten des Produkts (1/0),
         fremde Varianten stehen nie darin. */
      belongsToUs(data) {
        const pi = this.closest('product-info');
        const ids = [this.dataset.sectionId, pi && pi.dataset.section, pi && pi.dataset.originalSection];
        if (ids.filter(Boolean).indexOf(data.sectionId) !== -1) return true;
        return !!(data.variant && Object.prototype.hasOwnProperty.call(this.map, data.variant.id));
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }
    }
  );
}
